import React from 'react';
import PropTypes from 'prop-types';

const ActionButtonIcon = props => (
    <svg
        width="100%"
        height={props.size != null ? props.size : '159'}
        viewBox="0 0 159 159"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>Action Button</title>
        <g fill="#FC2A61" fillRule="evenodd">
            <path d="M57.64 155.413c6.827 1.932 14.04 2.95 21.484 2.95 43.703 0 79.13-35.426 79.13-79.123 0-29.382-16.01-55.023-39.783-68.67-4.166-2.394-8.933-1.2-10.65 4.213-1.718 5.41-15.547 52.088-15.547 52.088h32.693s-69.38 76.998-72.61 80.944c-2.944 3.595-7.205 3.46-7.205 3.46s9.58 3.312 12.49 4.14" />
            <path d="M.016 79.24c0 29.376 16.01 55.017 39.782 68.666 4.167 2.398 8.936 1.2 10.654-4.21 1.717-5.413 15.544-52.09 15.544-52.09h-32.71s67.31-74.794 70.458-78.616c4.583-5.566 7.764-5.376 7.764-5.376S106.74 4.78 100.615 3.06C93.78 1.15 86.575.11 79.13.11 35.425.108 0 35.536 0 79.24h.016" />
        </g>
    </svg>
);
ActionButtonIcon.propTypes = {
    size: PropTypes.number
};

export default ActionButtonIcon;
